<template lang="pug">
  .sv-select-component
    .card(v-for="(item, $index) in filteredItems")
      .card-content
        cv-item(:item="item" @selected="$emit('selected', $event)" :key="$index")
    infinite-loading(@infinite="loadData" :distance="10")
      div(slot="no-more") {{ gettext('No more cvs') }}
      div(slot="no-results") {{ gettext('No results cvs') }}
</template>
<script>
import InfiniteLoading from 'vue-infinite-loading'
import CvItem from '../cv-select-item'

import { mapActions } from 'vuex'
import { gettext } from '@/services/TranslateHandler'

export default {
  name: 'CVSelectComponent',
  components: {
    InfiniteLoading,
    CvItem
  },
  data () {
    return {
      page: 1,
      items: []
    }
  },
  methods: {
    ...mapActions([
      'jobseekerGetCvs'
    ]),
    gettext: gettext,
    loadData ($state) {
      this.jobseekerGetCvs({page: this.page, size: 10}).then(res => {
        if (this.page <= res.total_pages) {
          this.page += 1
          this.items = this.items.concat(res.items)
          $state.loaded()
        } else {
          $state.complete()
        }
      })
    }
  },
  computed: {
    filteredItems () {
      return this.items.filter(item => item.is_active)
    }
  }
}
</script>
<style lang="scss">
  .sv-select-component {
    .media-right {
       padding-top: 35px;
       padding-bottom: 35px;
    }
    span.tag.is-success {
      margin: 0 1px 1px 0;
    }
    .media-left {
      figure {
        margin-left: 0;
        margin-right: 0;
      }
    }
    .media-content {
      a.link {
        font-size: 12px;
        color: #23d160;
        margin-top: 0;
      }
      p {
        margin-bottom: 0.35em;
        &.subtitle {
          font-weight: 400;
          color: #908c8c;
          font-size: 12px;
        }
      }
    }
    .content {
      .notification {
        border-radius: 0;
        padding: 15px;
      }
    }
  }
  @media screen and (max-width: 540px){
    .sv-select-component{
      .media{
        flex-direction: column;
        align-content: center;
        align-items: center;
        &-left, &-right{
          margin: 0px;
        }
        &-right{
          padding: 10px 0;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/vacancy/parts/offer/components/cv-select/index.vue